
import respUtility from '@/mixins/respUtility';

export default {
  name: 'BrandReviews',
  mixins: [respUtility],
  props: {
    isReviews: {
      type: Boolean,
    },
    rating: {
      type: Object,
    },
    loading: {
      type: Boolean,
    },
    itemsReviewsBrand: {
      type: Array,
      default() {
        return [];
      },
    },
    sortMode: {
      type: String,
    },
  },
  computed: {
    isReviewsModel: {
      get() {
        return this.isReviews;
      },
      set(value) {
        this.$emit('toggle-reviews', value);
      },
    },
    isMobile() {
      return (this.$device.isMobileOrTablet || this.isTouchDevice);
    },
  },
  watch: {
    isRequestReviewsFirst(newValue) {
      if (newValue) {
        this.getBrandReviews();
      }
    },
  },
};
